module.exports = __webpack_public_path__ + "static/img/1.e96e9dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/eng/1.png
// module id = eWz3
// module chunks = 0